module.exports = __webpack_public_path__ + "img/sword-water-01.077a4ac7.png";